/* crm-financeiro/src/main.tsx */

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import ReactGA from "react-ga4"; // <--- Importe aqui
import './index.css'
import App from './App.tsx'
import { installChunkRecoveryListener } from './utils/chunkLoadRecovery'
import { registerVendaproPwa } from './utils/pwaRegistration'

const savedTheme = window.localStorage.getItem('theme');
const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;

if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
  document.documentElement.classList.add('dark');
} else {
  document.documentElement.classList.remove('dark');
}

installChunkRecoveryListener();
registerVendaproPwa();

const gaMeasurementId = String(import.meta.env.VITE_GA_MEASUREMENT_ID || '').trim();

if (gaMeasurementId) {
  ReactGA.initialize(gaMeasurementId, {
    gtagOptions: {
      cookie_domain: window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' ? 'none' : 'auto'
    }
  });

  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>,
)
